import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=6eb339f2&scoped=true&lang=less"

import exportComponent from "/Users/user/mscode/tecs/TECS-FE-ENDUSER-NEW/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6eb339f2"]])

export default __exports__